import { PlayActions } from "@/components/playlist/detail/PlayActions";
import { PlayActivity } from "@/components/playlist/detail/PlayActivity";
import { PlayInformation } from "@/components/playlist/detail/PlayInformation";
import { PlayStatus } from "@/components/playlist/detail/PlayStatus";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { getPlay } from "@/queries/plays";

type PlayDetailProps = {
  playId: number;
  onClose?: () => void;
};

// Main PlayDetail component
export function PlayDetail({ playId, onClose }: PlayDetailProps) {
  const { data: play, isLoading } = getPlay(playId);
  return (
    <div className="">
      <Card className="w-full  mx-auto text-white">
        {isLoading && <Skeleton className="w-full h-64" />}
        {play && (
          <>
            <PlayInformation play={play} onClose={onClose} />
            <CardContent className="space-y-6">
              <PlayStatus play={play} />
              <PlayActions play={play} />
              <PlayActivity play={play} />
            </CardContent>
          </>
        )}
      </Card>
    </div>
  );
}
